<template>
  <b-container>
    <b-row>
      <b-col md="12" class="d-flex justify-content-center m-2">
        <button 
          :class="{ 'clicked': activeButton === 'offers' }" 
          @click="onClickActiveBtn('offers')">
            Available Offers
        </button>
        <button 
          :class="{ 'clicked': activeButton === 'packages' }" 
          @click="onClickActiveBtn('packages')">
            All Packages
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, index) in dummyData" :key="index" md="3">
        <div  class="card text-center">
          <h3 class="card-header">Basic Package</h3>
          <div class="card-body">
            <h3 class="card-title mt-1">₹ 2200</h3>
            <h3 class="card-text">Preventive Health Checkup</h3>
            <br>
            
            <p class="card-text">
              <small class="">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur cupiditate non corporis cumque quis
                saepe
              </small>
            </p>

            <b-icon @click="onArrowIconClick" class="right-icon" icon="arrow-right-circle"></b-icon>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "packageTests",
    components: {},
    data() {
      return { 
        activeButton: 'offers',
        dummyData: [
        { title: 'Card 1', description: 'Description for Card 1' },
        { title: 'Card 2', description: 'Description for Card 2' },
        { title: 'Card 3', description: 'Description for Card 3' },
        { title: 'Card 4', description: 'Description for Card 4' },
      ]
       };
    },
    computed: {
      
    },
    methods: {
      onClickActiveBtn(button) {
      this.activeButton = button;
    },
      onArrowIconClick(){
        this.$router.push({
        name: 'product-view',
        params: {  },
      });
      },
    },
    async mounted() {
      
    },
  };
</script>
  
<style scoped>
  .card-header {
    background: #f9d039;
    font-size: 18px;
    font-weight: 500px;
    line-height: 24px;
  }
  .card-body {
    background: #0050b3;
    color: #fff;
    padding: 14px;
    border-radius: 0 0 8px 8px;
  }
  .card-text{
    font-size: 14px;
  }
  .right-icon {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
  .card {
    height: 340px;
    border-radius: 8px;
  }
  button {
    background-color: white;
    color: black;
    padding: 5px 15px;
    cursor: pointer;
    border: 2px solid rgba(0, 0, 0, 0.2);    
    border-radius: 5px;
  }
  
  .clicked {
    background-color: black;
    color: white;
  }
</style>
  